import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';

import * as organizationSelectors from '../../selectors/organizationSelectors';
import Paper from '@material-ui/core/Paper';

const NoOrganizations = ({ classes, isLoadingOrganizations }) => {
    if (isLoadingOrganizations) {
        return null;
    }

    return (
        <Paper square elevation={1} className={classes.wrapper}>
            <div className={classes.content}>
                You are currently not a member of any organization. Please
                contact us if you want to create new organization. If you think
                you should be part of some organization please contact your
                organization administrator.
            </div>
        </Paper>
    );
};

NoOrganizations.propTypes = {
    isLoadingOrganizations: PropTypes.bool.isRequired,
};

NoOrganizations.defaultProps = {};

const mapStateToProps = state => ({
    isLoadingOrganizations: organizationSelectors.getIsLoadingOrganizations(
        state,
    ),
});

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: spacing.unit * 6,
    },
    content: {
        width: '100%',
        maxWidth: spacing.maxWidth,
        padding: spacing.unit * 4,
    },
});

export default connect(mapStateToProps)(injectSheet(style)(NoOrganizations));



// WEBPACK FOOTER //
// ./src/containers/noOrganizations/NoOrganizations.js